import { defineComponent as d, computed as l, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as f, normalizeStyle as n, createStaticVNode as m } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "9218091b-d25c-4e78-9fc8-af41b4d2f058" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#9218091b-d25c-4e78-9fc8-af41b4d2f058)" }, u = { key: 0 }, v = /* @__PURE__ */ m('<path fill="#ffda44" d="M23.6 23.7h464.8v464.7H23.6z"></path><path fill="#496e2d" d="M0 75.1 38 38l436.3 436.4 37.7-37.5V75l-39.6-35.5L40.2 471.8 0 436.8z"></path><circle cx="256" cy="256.1" r="89" fill="#a2001d"></circle><path fill="#ffda44" d="m256 167 20 61.5h64.6l-52.3 38 20 61.3-52.3-38-52.3 38 20-61.3-52.3-38H236zM256 .2z"></path><path fill="#a2001d" d="M0 0h512v75.1H0zm0 436.8h512v75.1H0z"></path><path fill="#ffda44" d="m256 28 4.1 12.7h13.5l-10.9 8 4.2 12.6-10.9-7.9-10.8 8 4.1-12.8-10.9-8H252zm-62 0 4 12.7h13.5l-10.9 8 4.2 12.6-10.9-7.9-10.8 8 4.1-12.8-10.8-8h13.4zm124 0 4.2 12.7h13.4l-10.8 8 4.1 12.6-10.8-7.9-10.9 8 4.2-12.8-10.9-8H314zm-62 422.8 4.1 12.7h13.5l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.9-7.9H252zm-62 0 4 12.7h13.5l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.8-7.9h13.4zm124 0 4.2 12.7h13.4l-10.8 8 4.1 12.7-10.8-8-10.9 8 4.2-12.8-10.9-7.9H314zm-240-199a22.3 22.3 0 0 1-37.6 23.9c-12-18.8-5-49.5-5-49.5S66 233 78 251.9z"></path><circle cx="65.1" cy="273.2" r="11.1" fill="#a2001d"></circle>', 7), z = { fill: "none" }, g = ["r"], w = /* @__PURE__ */ d({
  __name: "gd",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), s = l(() => 256 + e.strokeWidth / 2);
    return (x, y) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (a(), i("title", u, h(e.flagName), 1)) : f("", !0),
        v
      ]),
      t("g", z, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: s.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, g)
      ])
    ], 8, p));
  }
});
export {
  w as default
};
//# sourceMappingURL=gd-9ff32119.js.map
